import { getBookingDetailDataAction } from "../../../Actions/LogicActions/BookingDetail/GetBookingDetailDataAction";
import { getBookingDetailStatusAction } from "../../../Actions/UIActions/BookingDetail/GetBookingDetailStatusAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { IGetBookingDetailsActionParams, IGetBookingDetailStatusActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";
import { BookingDetailContext } from "../Context/BookingDetailContext";



class BookingDetailInitStep extends StepFlow {
    get stepName() { return "BookingDetailInit_Step"; }

    async onEventSetup(): Promise<void> {
    }

    async onExecute(): Promise<void> {
        this.setCtx("bookingDetailContext", BookingDetailContext)
        console.log("Booking Detail Initial Step Executed.....");
        this.next();
    }
}

export const BookingDetailInitStepDeclaration = new StepDefinition({
    stepName: "BookingDetailInit_Step",
    stepClass: BookingDetailInitStep
});